import { Splide, SplideSlide } from '@splidejs/react-splide';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { isEmpty } from 'validate.js';

import { isLessThanBreakpoint } from 'dpl/util/grid';
import { ANALYTICS_VIEW_FEATURE_LOCATIONS } from 'dpl/constants/analytics';

import BreederProfileLitterPuppyCard, {
  PuppyPropTypes
} from '../BreederProfileLitterPuppyCard';
import useBreederProfileMobileLayout from '../../hooks/useBreederProfileMobileLayout';

const IS_LT_MD = isLessThanBreakpoint('md');
const IS_LT_LG = isLessThanBreakpoint('lg');

function getNumberOfCardsPerPage() {
  if (IS_LT_MD) return 1;
  if (IS_LT_LG) return 3;

  return 4;
}

const CARDS_PER_PAGE = getNumberOfCardsPerPage();

export default function BreederProfilePastPuppiesCarousel({
  breederProfileId,
  puppies,
  className
}) {
  const { isNewMobileLayout } = useBreederProfileMobileLayout();
  const splideRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const puppyCount = puppies.length;

  if (isEmpty(puppies)) {
    return null;
  }

  return (
    <div
      className={classnames(
        'BreederProfilePastPuppiesCarousel bg-subtle-light-gray pv8 pv20-md overflow-hidden',
        className
      )}
    >
      <div className="container-xxl">
        <div className="mb5 mb6-md">
          <h3 className="lh-title font-24 md:font-40 mb1">Matched puppies</h3>
          <p className="font-16 md:font-18 secondary">
            These puppies are already reserved or have gone home to their new
            families.
          </p>
        </div>
        <Splide
          ref={splideRef}
          onActive={({ index }) => setActiveIndex(index)}
          options={{
            arrows: false,
            drag: puppyCount > CARDS_PER_PAGE,
            dragMinThreshold: 20,
            flickMaxPages: CARDS_PER_PAGE,
            flickPower: 300,
            gap: IS_LT_MD ? 8 : 16,
            keyboard: 'focused',
            pagination: false,
            perPage: CARDS_PER_PAGE,
            snap: true,
            start: activeIndex
          }}
        >
          {puppies.map((puppy, puppyIndex) => (
            <SplideSlide key={puppy.id}>
              <BreederProfileLitterPuppyCard
                puppy={puppy}
                breederProfileId={breederProfileId}
                analytics={{
                  position: puppyIndex + 1,
                  ...(isNewMobileLayout && {
                    view_feature_location:
                      ANALYTICS_VIEW_FEATURE_LOCATIONS.PAST_PUPPIES
                  })
                }}
              />
            </SplideSlide>
          ))}
        </Splide>
      </div>
    </div>
  );
}

BreederProfilePastPuppiesCarousel.propTypes = {
  breederProfileId: PropTypes.string.isRequired,
  puppies: PropTypes.arrayOf(PuppyPropTypes).isRequired,
  className: PropTypes.string
};

BreederProfilePastPuppiesCarousel.defaultProps = {
  className: null
};
